export default "<img class=\"pattern-preview\" [src]=\"sewingPatternSVGImage\" alt=\"\" #image />\n";